import { useEffect } from "react";
import { useT } from "@transifex/react";
import { useFormContext } from "react-hook-form";
import { Checkbox } from "storybook/components/checkbox";
import { TakeActionType, WeekDay } from "../schema";
import {
  Container,
  CheckList,
  InputsContainer,
  DayTimesContainer,
} from "./styles";

const options = {
  shouldValidate: true,
};

const AvailabilityItem = ({
  label,
  name,
}: {
  label: string;
  name: WeekDay;
}) => {
  const t = useT();
  const { setValue, watch } = useFormContext<TakeActionType>();
  const state = watch(`preferredAppointmentAvailability.${name}`);

  useEffect(() => {
    if (state.enabled) {
      setValue(`preferredAppointmentAvailability.anytime`, false, options);
    } else {
      setValue(`preferredAppointmentAvailability.${name}.am`, false, options);
      setValue(`preferredAppointmentAvailability.${name}.pm`, false, options);
    }
  }, [state.enabled, name, setValue]);

  useEffect(() => {
    if (!state.am && !state.pm) {
      setValue(
        `preferredAppointmentAvailability.${name}.enabled`,
        false,
        options
      );
    }

    if (state.am || state.pm) {
      setValue(
        `preferredAppointmentAvailability.${name}.enabled`,
        true,
        options
      );
    }
  }, [state.am, state.pm, name, setValue]);

  useEffect(() => {
    if (state.enabled && !state.am && !state.pm) {
      setValue(`preferredAppointmentAvailability.${name}.am`, true, options);
      setValue(`preferredAppointmentAvailability.${name}.pm`, true, options);
    }
  }, [state.enabled, state.am, state.pm, name, setValue]);

  return (
    <div>
      <Checkbox
        size="small"
        hideDirty={true}
        label={label}
        theme="patient-facing"
        name={`preferredAppointmentAvailability.${name}.enabled`}
      />
      <DayTimesContainer>
        <Checkbox
          size="small"
          hideDirty={true}
          button={true}
          label={t("AM")}
          theme="patient-facing"
          name={`preferredAppointmentAvailability.${name}.am`}
        />
        <Checkbox
          size="small"
          hideDirty={true}
          button={true}
          label={t("PM")}
          theme="patient-facing"
          name={`preferredAppointmentAvailability.${name}.pm`}
        />
      </DayTimesContainer>
    </div>
  );
};

export function PreferredAppointmentAvailability() {
  const t = useT();
  const { setValue, watch } = useFormContext<TakeActionType>();
  const isAnytimeEnabled = watch("preferredAppointmentAvailability.anytime");

  useEffect(() => {
    if (isAnytimeEnabled) {
      setValue(
        "preferredAppointmentAvailability.monday.enabled",
        false,
        options
      );
      setValue(
        "preferredAppointmentAvailability.tuesday.enabled",
        false,
        options
      );
      setValue(
        "preferredAppointmentAvailability.wednesday.enabled",
        false,
        options
      );
      setValue(
        "preferredAppointmentAvailability.thursday.enabled",
        false,
        options
      );
      setValue(
        "preferredAppointmentAvailability.friday.enabled",
        false,
        options
      );
    }
  }, [isAnytimeEnabled, setValue]);

  return (
    <Container>
      <InputsContainer data-id="InputsContainer">
        <CheckList>
          <Checkbox
            size="small"
            hideDirty={true}
            theme="patient-facing"
            name="preferredAppointmentAvailability.anytime"
            label={t("Flexible - Available Anytime")}
          />
          <AvailabilityItem label={t("Monday")} name="monday" />
          <AvailabilityItem label={t("Tuesday")} name="tuesday" />
          <AvailabilityItem label={t("Wednesday")} name="wednesday" />
          <AvailabilityItem label={t("Thursday")} name="thursday" />
          <AvailabilityItem label={t("Friday")} name="friday" />
        </CheckList>
      </InputsContainer>
    </Container>
  );
}
